import React from 'react';
import {
  ButtonContainer,
  StyledErrorBoundaryComponent,
} from './ErrorBoundaryComponent.styled';
import { useTranslation } from 'react-i18next';
import EmptySearch from '../../icons/EmptySearch';
import { Headline1 } from '../../typography';
import { ButtonBlockColumn } from './../../sharedStyledComponents/GenericStyles.styled';
import { ButtonLarge } from '../buttons/ButtonLarge';
import { ClearAllIndexedDB } from '../../../../indexed';
import { clear, getItem } from '../../../../utils/localStorage';
import { logOutUser } from '../../../../requests/login';

export interface IErrorBoundaryComponent {}

export function ErrorBoundaryComponent () {
  const { t } = useTranslation();

  const handleBackToLogin = () => {
    ClearAllIndexedDB();
    const userData = getItem('user');
    const accessToken = userData.accessToken;
    logOutUser(accessToken)
      .then(() => {
        clear();
        window.location.href = '/login';
      })
      .catch((err) => {
        console.error('err', err);
      });
  };
  return (
    <StyledErrorBoundaryComponent>
      <EmptySearch />
      <Headline1>{t('COMMON.ERROR_BOUNDARIES.SOMETHING_WENT_WRONG')}</Headline1>
      <ButtonContainer>
        <ButtonBlockColumn>
          <ButtonLarge
            title={t('COMMON.ERROR_BOUNDARIES.BUTTON.DASHBOARD')}
            onClick={() => (window.location.href = '/dashboard')}
          />
          <ButtonLarge
            outlined={true}
            inverted={true}
            title={t('COMMON.ERROR_BOUNDARIES.BUTTON.LOGIN')}
            onClick={handleBackToLogin}
          />
        </ButtonBlockColumn>
      </ButtonContainer>
    </StyledErrorBoundaryComponent>
  );
}
